import { useCallback, useRef } from "react";

interface UsePaginationChangeHandlersOptions {
	/** Recibe el índice de página en base 0. */
	onPageIndexChange: (pageIndex: number) => void;
	onPageSizeChange: (pageSize: number) => void;
}

export function usePaginationChangeHandlers({
	onPageIndexChange,
	onPageSizeChange,
}: UsePaginationChangeHandlersOptions) {
	const isPageSizeChanging = useRef(false);

	const handlePageSizeChange = useCallback(
		(newPageSize: number) => {
			isPageSizeChanging.current = true;
			queueMicrotask(() => {
				isPageSizeChanging.current = false;
			});
			onPageSizeChange(newPageSize);
		},
		[onPageSizeChange],
	);

	/** `uiPageIndex` llega en base 1 desde DevExtreme. */
	const handlePageIndexChange = useCallback(
		(uiPageIndex: number) => {
			if (isPageSizeChanging.current) return;
			onPageIndexChange(Math.max(0, uiPageIndex - 1));
		},
		[onPageIndexChange],
	);

	return { handlePageIndexChange, handlePageSizeChange };
}
